import { createContent, getDisplayAssetCode } from '@altify/utils';

export const content = createContent({
  en: {
    title: (productCode?: string, productName?: string) =>
      productName
        ? `Buy ${productName} (${getDisplayAssetCode(productCode)})`
        : '',
  },
  de: {
    title: (productCode?: string, productName?: string) =>
      productName
        ? `Kaufe ${productName} (${getDisplayAssetCode(productCode)})`
        : '',
  },
});
